"use client";

import { useQueryState } from "nuqs";
import { PasswordRecoveryModal } from "./password-recovery-modal";
import { PasswordResetModal } from "./password-reset-modal";
import AuthenticationFormModal from "./authentication-form-modal";
import { AuthAction } from "@/enums/auth-actions";
import { useAuth } from "../auth-provider";
import { useEffect } from "react";

export function AuthModalsManager() {
  const [authParam, setAuthParam] = useQueryState("auth", {
    defaultValue: "",
    clearOnDefault: true,
  });
  const { claims } = useAuth();

  useEffect(() => {
    if (claims && !claims.is_anonymous && authParam) {
      setAuthParam(null);
    }
  }, [claims, authParam, setAuthParam]);

  const handlePasswordRecoveryChange = (open: boolean) => {
    if (!open) {
      setAuthParam(null);
    }
  };

  const handlePasswordResetChange = (open: boolean) => {
    if (!open) {
      setAuthParam(null);
    }
  };

  return (
    <>
      <AuthenticationFormModal />

      <PasswordRecoveryModal
        open={authParam === AuthAction.PASSWORD_RECOVERY}
        onOpenChange={handlePasswordRecoveryChange}
      />
      <PasswordResetModal
        open={authParam === AuthAction.PASSWORD_RESET}
        onOpenChange={handlePasswordResetChange}
      />
    </>
  );
}
